export const LOAD_PRODUCT_GROUPS_SUCCESS = 'LOAD_PRODUCT_GROUPS_SUCCESS';
export const CREATE_PRODUCT_GROUP_SUCCESS = 'CREATE_PRODUCT_GROUP_SUCCESS';
export const NEW_PRODUCT_GROUP_SUCCESS = 'NEW_PRODUCT_GROUP_SUCCESS';
export const DELETE_PRODUCT_GROUP_SUCCESS = 'DELETE_PRODUCT_GROUP_SUCCESS';
export const LOAD_EDIT_PRODUCT_GROUP_SUCCESS = 'LOAD_EDIT_PRODUCT_GROUP_SUCCESS';
export const UPDATE_PRODUCT_GROUP_SUCCESS = 'UPDATE_PRODUCT_GROUP_SUCCESS';
